import { createFileRoute, useRouter } from "@tanstack/react-router";

import { Button } from "@chartvn/ui/button";

import { BreakGlassScreen } from "../../../features/platform/components/break-glass-screen";

/**
 * A resident's entry, opened from the platform console (`RPM-064` rows 3 and 4, `NE-08`, `J-297`).
 *
 * The address names the entry by its opaque id and nothing else (`.claude/rules/phi.md` rule 2). The
 * entry reads No access to patient data until a reason is declared under Break glass; nothing of it is
 * kept once the screen is left.
 */
function PlatformEntryRoute() {
  const { entryId } = Route.useParams();
  const router = useRouter();
  return (
    <div className="flex flex-col gap-4 pt-4">
      <div>
        <Button
          type="button"
          variant="outline"
          className="min-h-11"
          onClick={() => void router.navigate({ to: "/platform" })}
        >
          Back to the platform console
        </Button>
      </div>
      <BreakGlassScreen key={entryId} entryId={entryId} />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/platform/entries/$entryId")({
  staticData: { screenName: "A resident's entry" },
  component: PlatformEntryRoute,
});
